import React from 'react';
import classNames from 'classnames';

import styles from './cardStyles.scss';

const Card: React.FC<{ children?: React.ReactNode; customStyles?: string }> = ({
  children,
  customStyles
}): React.ReactElement => {
  return <div className={classNames(styles.cardContainer, customStyles)}>{children}</div>;
};

export default Card;
